import React,{ Component} from 'react';
import * as ShipConstants from '../../../Global/Constants';
// import Wrp from '../../../../hoc/Wrp/Wrp';
import Modal from "react-bootstrap/Modal";
import FormInputFields from '../../../Components/FormInputFields';
import Buttons from '../../../Components/UI/Buttons';
import { withRouter } from 'react-router';
import * as actions from '../../../store/actions';
import { connect } from 'react-redux';
import {decimalOptions,isSet,setArrayIndexes} from '../../../Utils/CommonFunctions';
import http from '../../../services/http';
import HeaderTabs from '../../../Components/UI/HeaderTabs';
// import Autocomplete from '../../../../Components/AutoComplete';
import {formInputFieldsKeyRef} from '../../../Containers/ShippingContainer/ShippingFunction';
// import DrillDown from '../../../../../Components/DrillDown';
import $ from 'jquery';
import WindowMapFields from '../../../Containers/StepsFlowContainer/StepsCustomize/StepsSidebar/Variables/WindowMapFields';
import ArrayElement from '../../../Components/ArrayElement';
import {ErrorDefaultFields} from '../../../Components/ArrayElement/ErrorDefaultFields';
import Icons from '../../../Components/Icons/Icons';
import {ErrorBlock} from '../../../hoc/FormInput';


class CreateNewVariable extends Component{
    constructor(props) {
      super(props);
      this.state = {
        windowsList: [{
          label:'',
          value:''
        }],
        violations:{},
        displayName:'',
        selectedWindowId:'',
        selectedWindow:'',
        windowFields:[],
        fieldsList:[],
        isArrayElementModalOpen:false,
        payload:{
            function_type:'AUTOMATION',
            variable_name:'',
            variable_type:'GLOBAL',
            is_constant:true,
            constant_value:'',
            fieldtype_id:'',
            is_response:false,
            is_request:false,
            window_field_id_path:'',
            max_value:0,
            decimal_places:0,
            apirequest_id:null,
            field_expression:'',
            fields: [],
            api_name:'',
            table_descriptor_id:''
        },
        errorDefaultFields:[
        {
          "name": "type",
          "field_type_id": "",
          "fieldtype_name": "",
          "indexes": ",0",
          "max_value": 0,
          "decimal_places": 0,
          "fields": [],
          "field_expression": "",
          "displayPosition": 1
        },
        {
          "name": "message",
          "field_type_id": "",
          "fieldtype_name": "",
          "indexes": ",1",
          "max_value": 0,
          "decimal_places": 0,
          "fields": [],
          "field_expression": "",
          "displayPosition": 2
        }
        ]
      }
    }
    componentDidMount = ()=>{
        try{
            if(isSet(this.props.formDetails.id,null)!==null){
                // console.log('setArrayIndexes(this.props.formDetails)',setArrayIndexes(this.props.formDetails));
                this.setState({
                    payload:setArrayIndexes(this.props.formDetails)
                });
                // console.log('this.props.formDetails',this.props.formDetails);
                this.generateWindowFields(this.props.formDetails.window_id)
            }
        }catch(e){
            
        }
        
        this.fetchWindowsList();
    }

    arrayChangeHandler = (e,ind) => {
        const {name,value} = e.target;
        const updateState = {...this.state};
        const data = updateState.payload;
        let indArr = ind.split(",");
        let cleanArr = indArr.filter((a) => a);
        let str = 'data.';
        cleanArr.map((item,iInd) => {
            str += cleanArr.length === iInd+1 ? "fields["+item+"]" : "fields["+item+"].";
        })
        let dat = eval(str);
        if(name === "field_type_id") {
            const fieldName = e.target.selectedOptions[0].text;
            dat["fieldtype_name"]=fieldName;
            // dat["field_expression"]="";
        }
        dat[name]=value;
        this.setState(updateState);
    }

    addArrayRow = (ind='') => {
        const updateState = {...this.state};
        const data = updateState.payload;
        const addArrayElementRow =  {
                "name": "",
                "field_type_id": "",
                "fieldtype_name": "",
                "indexes":"",
                "max_value":0,
                "decimal_places":0,
                "fields": [],
                "field_expression":""
            }

        if(ind !== "") {
            let indArr = ind.split(",");
            let cleanArr = indArr.filter((a) => a);
            let str = 'data.';
            cleanArr.map((item,iInd) => {
                str += cleanArr.length === iInd+1 ? "fields["+item+"]" : "fields["+item+"].";
            })
            let dat = eval(str);
            dat.fields.push(addArrayElementRow); 
            setArrayIndexes(data);  
            this.setState(updateState);
        }else {
            data.fields.push(addArrayElementRow);   
            setArrayIndexes(data);
            this.setState(updateState);
        }
    }

    deleteArrayRow = (ind) => {
        const updateState = {...this.state};
        const data = updateState.payload;
        let indArr = ind.split(",");
        let cleanArr = indArr.filter((a) => a);
        if(cleanArr.length === 1) {
            data.fields.splice(cleanArr[0], 1); 
        }else {
            let lastElement = cleanArr[cleanArr.length - 1];
            // cleanArr = cleanArr.pop();
            let newArr = [];
            newArr.push.apply(newArr, cleanArr);
            newArr.pop();
            console.log(cleanArr,lastElement,newArr)
            let str = 'data.';
            newArr.map((item,iInd) => {
                str += newArr.length === iInd+1 ? "fields["+item+"]" : "fields["+item+"].";
            })
            let dat = eval(str);
            dat.fields.splice(lastElement, 1); 
        }
        setArrayIndexes(data);  
        this.setState(updateState);
    }


    checkThisIsErrorFieldType = () => {        
        
        const updateState = {...this.state};
        const data = updateState.payload;    
        console.log('data==',data)    
        if(isSet(data.id,null)===null){

            let getFieldTypeName = '';            
            if(this.props.variableFieldTypes){
                const fieldTypeIndex = this.props.variableFieldTypes.findIndex(i=>i.id===data.fieldtype_id);                                        
                if(fieldTypeIndex!==-1){
                    getFieldTypeName = this.props.variableFieldTypes[fieldTypeIndex].type_name;
                }

                if(getFieldTypeName==='Messages'){
                    let field_type_id = '';
                    let fieldtype_name = 'TextInput';
                    data['fields'] = this.state.errorDefaultFields;
                    if(isSet(this.props.variableFieldTypes,[]).length>0){                    
                        const fieldTypeIndexByName = this.props.variableFieldTypes.findIndex(i=>i.type_name===fieldtype_name);                                        
                        if(fieldTypeIndexByName!==-1){
                            field_type_id = this.props.variableFieldTypes[fieldTypeIndexByName].id;
                        }
                        data['fields'][0]['field_type_id'] = field_type_id;
                        data['fields'][0]['fieldtype_name'] = fieldtype_name;
                        data['fields'][1]['field_type_id'] = field_type_id;
                        data['fields'][1]['fieldtype_name'] = fieldtype_name;  
                    }
                    this.setState(updateState);
                    this.toogleArrayElementModel();
                }else{
                    this.toogleArrayElementModel();    
                }     
            }else{
                this.toogleArrayElementModel();    
            }                        
        }else{
            this.toogleArrayElementModel();
        }
    }

    
    

    render(){        
        const {variablesAndFields,isCreateVariableModelOpen,currentTab,toggleCreateVaiableModel,
        triggerEffect,Loader,saveVariableAndFields,succMessage,failMessage,editData} = this.props;
        //this.getSelectedDrillDownOptions();
        const {payload,windowsList,windowFields,selectedWindow} = this.state;


        //console.log('windowFields==',windowFields)
        //console.log('payload==',payload)

        const {variable_name,constant_value,is_constant,apirequest_id,field_expression,variable_type,max_value,decimal_places,fieldtype_id,is_request,is_response} = payload;
        const fieldTypeIndex = this.props.variableFieldTypes.findIndex(i=>i.id===fieldtype_id);
        let fieldtype_name = null;
        if(fieldTypeIndex!==-1){
            fieldtype_name = this.props.variableFieldTypes[fieldTypeIndex].type_name;
        }
        let constantAttributes={}
        if(fieldtype_name === 'Decimal'){
            constantAttributes={
                maxLength:Number(max_value),
                decimal:Number(decimal_places)
            }
            
        }
        const formFields = [
            {
                type:'TextInput',
                label:(is_constant===true)?'Constant Name':'Variable Name',
                value:variable_name,
                violation_name:'name',
                changeHandler:(val)=>this.updatePayload({...payload,variable_name:val},'name'),
                attributes:{
                    disabled:(isSet(payload.id,null)!==null)?true:false
                }
            },
            {
                type:'PickList',
                label:'Field Type',
                isDefault:true,
                violation_name:'type',
                value:fieldtype_id,
                options:[{value:'-None-',id:''},...this.props.variableFieldTypes.map(({type_name,id})=>{
                    return{
                        value:type_name,
                        id:id
                    }
                })],
                attributes:{
                    disabled:(isSet(payload.id,null)!==null)?true:false
                },
                changeHandler:(val)=>this.updatePayload({...payload,fieldtype_id:val})
            },
            (fieldtype_name==='Decimal')?
            {
                type:'PickList',
                label:'Max Digits',
                isDefault:true,
                violation_name:'max',
                value:max_value,
                options:[{value:'-None-',id:''},...decimalOptions().map((value,index)=>{
                    return{
                        id:value,
                        value:value
                    }
                })],
                changeHandler:(val)=>this.updatePayload({...payload,max_value:val})
            }:null,
            (fieldtype_name==='Decimal')?
            {
                type:'PickList',
                label:'Decimal',
                violation_name:'dec',
                isDefault:true,
                value:decimal_places,
                options:[{value:'-None-',id:''},...decimalOptions(max_value).map((value,index)=>{
                    return{
                        id:value,
                        value:value
                    }
                })],
                attributes:{style:{display:(fieldtype_name==='Decimal')?'':'none'}},
                changeHandler:(val)=>this.updatePayload({...payload,decimal_places:val})
            }:null, 
            (payload.is_constant===true)?{
                type:formInputFieldsKeyRef(fieldtype_name),//'TextInput',
                label:'Constant Value',
                value:constant_value,
                violation_name:'value',
                isDefault:false,
                attributes:{
                    ...constantAttributes,
                    id:'constant_value'
                },
                changeHandler:(val)=>this.updatePayload({...payload,constant_value:val})
            }:null,
        ]
        const buttonList =  [
            {
                attributes:{
                className:"btn border-default btn-border mr-2 cursor-pointer",
                },
                clickHandler:toggleCreateVaiableModel,
                name:"Cancel"
            },  
            {
            attributes:{
                className:"btn primary_bg cursor-pointer"
            },
            clickHandler:this.saveHandler,
            name:"Save"
        }]
        const headerTabsList = [
            {
                name:"Constant",
                attributes:{
                  "aria-selected":false,
                  className:(is_constant==true)? "nav-link submenu active show" : "nav-link" 
                },
                access_mode:true,
                clickHandler:()=>(isSet(payload.id,null)!==null)?{}:this.updatePayload({...payload,is_constant:true,is_request:false,is_response:false})
            },
            {
                name:"Input Variable",
                attributes:{
                  "aria-selected":false,
                  className:(is_request===true)? "nav-link submenu active show" : "nav-link" 
                },
                access_mode:true,
                clickHandler:()=>(isSet(payload.id,null)!==null)?{}:this.updatePayload({...payload,is_constant:false,is_request:true,is_response:false})
            },
            {
                name:"Output Variable",
                attributes:{
                  "aria-selected":false,
                  className:(is_response===true)? "nav-link submenu active show" : "nav-link" 
                },
                access_mode:true,
                clickHandler:()=>(isSet(payload.id,null)!==null)?{}:this.updatePayload({...payload,is_constant:false,is_request:false,is_response:true})
            }
        ];
        //console.log('payload',payload);
        return(
            <Modal size="lg" show={true}>
            <Modal.Header>
                {/* <h5 className="modal-title secondary_color pl-2">{(isSet(payload.id,null)!==null)?'Update':'Add'} Resource </h5> */}
                <HeaderTabs 
                    attributes={{className:"nav nav-pills navcrm-primary nav-pills-no-bd"}} 
                    headerTabsList={headerTabsList}
                        />
            </Modal.Header>
            <Modal.Body>

                <div className="row">
                    {formFields.map((item,itemIndex)=>{
                        if(item===null){return false;}
                        return(
                            <div className="col-6" key={itemIndex}>
                                <div className="form-group">
                                    <label> {item.label} </label>
                                    <div className='input-group'>
                                        <FormInputFields {...item} />
                                        {item.label==='Field Type' && (fieldtype_name==='Array' || fieldtype_name==='Object' || fieldtype_name==='Messages')?
                                            <div className='input-group-append cursor-pointer'onClick={this.checkThisIsErrorFieldType} title={"Add "+fieldtype_name+' Element'}>
                                                <span className='input-group-text'>
                                                    <a className=" arrPlusIcon" >
                                                        <Icons iconType='AddPlusTwo'/>
                                                    </a>
                                                </span>
                                            </div>
                                            // <a className="cursor-pointer" onClick={this.toogleArrayElementModel}>
                                            //     <span className="svgIcon"> </span> Add {fieldtype_name} Element
                                            // </a>
                                        :null}
                                    </div>
                                    <ErrorBlock message={isSet(this.state.violations[item.violation_name],'')}/>
                                </div>
                            </div>
                        )
                    })}
                </div>
 
            </Modal.Body>

            <Modal.Footer>
                <Buttons buttonList={buttonList} />
            </Modal.Footer>
            {(this.state.isArrayElementModalOpen===true)?
                <ArrayElement
                    toogleArrayElementModel={this.toogleArrayElementModel}
                    arrayElement={payload}
                    changeHandler={this.arrayChangeHandler}
                    addRow={this.addArrayRow}
                    deleteRow={this.deleteArrayRow}
                    isArrayElementModalOpen={this.state.isArrayElementModalOpen}
                    variablesAndFields={this.props.variableFieldTypes}
                    currentTab={payload.is_constant === true ? 'constant':'VARIABLE' }
                    screen={"Steps"}>
                        {(fieldtype_name==='Object' || fieldtype_name=='Array')?
                            <WindowMapFields 
                                generateWindowFields={this.generateWindowFields}
                                variablesAndFields={this.props.variableFieldTypes}
                                isAssignFieldOnly={false} 
                                windowsList={windowsList}
                                windowFields={windowFields}
                                updateWindowId={(winId)=>this.updatePayload({...payload,'window_id':winId})}
                                updateFields={(fields)=>this.updatePayload({...payload,'fields':fields})}
                                payload={payload}
                                screen={"Steps"}
                                function_type={'AUTOMATION'}
                            />
                        :<></>}
                        
                </ArrayElement>
            :<></>}
            
        </Modal>
        )
    }

    toogleArrayElementModel = (arrayData) => {
        this.setState({isArrayElementModalOpen:!this.state.isArrayElementModalOpen});
      }

    updatePayload  = (updatePayload,violation='none')=>{
        this.setState({
            payload:updatePayload,
            violations:{
                ...this.state.violations,
                [violation]:''
            }
        })   
    }
    getSelectedDrillDownOptions = ()=>{
        const {payload} = this.state;
        let selectedDD = [];
        const splitExp = isSet(payload.window_field_id_path,'').replace(/_/g, " ").split('.');
        try{
            splitExp.map((field,index)=>{
                isSet(this.state.windowFields.fields_with_filters.window_fields,[]).map((itm)=>{
                    if(field===itm.id || field===itm.lookup_window_name){
                        selectedDD.push(itm);
                        // console.log('itm',itm);
                        const arr = this.dependentLayoutOptios(splitExp.filter((i,inx)=>{
                            if(index<inx){return i;} 
                        }),itm.dependent_layout,selectedDD)
                        selectedDD = [...selectedDD,...arr];
                    }
                })
            })
        }catch(e){

        }
        // console.log('selectedDD',selectedDD);
        return selectedDD;
        
    }
    dependentLayoutOptios = (splitExp,windowFields)=>{
        let selectedDD = [];
        // console.log('splitExp',splitExp,windowFields);
        try{
            splitExp.map((field,index)=>{
                isSet(windowFields.fields_with_filters.window_fields,[]).map((itm)=>{
                    if(field===itm.id || field===itm.lookup_window_name){
                        selectedDD.push(itm);
                        const arr = this.dependentLayoutOptios(splitExp.filter((i,inx)=>{
                            if(index<inx){return i;} 
                        }),itm.dependent_layout)
                        selectedDD = [...selectedDD,...arr];
                        // console.log('itm.window_field_name_path',itm);
                    }
                })
            })
        }catch(e){

        }
        return selectedDD;
    }
    drillDownChangeHandler = (selectedValue)=>{
        let fieldExp = '';
        selectedValue.map((itm)=>{
            fieldExp = itm.window_field_id_path
        })
        let updateExp = fieldExp.replace(/ /g, "_");
        // console.log('updateExp',updateExp,selectedValue);
         
        this.updatePayload({...this.state.payload,window_field_id_path:updateExp});
    }
    //AUTOCOMPLETE ON SELECT
    autoCompleteSelect = (obj) =>{
        this.setState({
          showFieldsContent:false
        })
        this.generateWindowFields(obj.value);
        setTimeout(() => {
          this.setState({
            selectedWindow:obj.label,
            selectedWindowId:obj.value,
            showFieldsContent:true
          });
        }, 200);
        
      }
  
      //AUTOCOMPLETE SEARCH TRIGGER
      autoCompleteSearch = (value) =>{
        this.setState({displayName:value});
        this.fetchWindowsList(value);
      }  
    fetchWindowsList = (search='') => {
        this.setState({
          selectedWindow:search
        })
        const page = 0; 
        const orderBy = 'display_name'; 
        const perPage = 100; 
        const direction = 'ASC';
        const queryString = '?query='+search+'&page='+page+'&orderBy='+orderBy+'&size='+perPage+'&direction='+direction;
        http.GET("windows/list"+queryString)
        .then(res => {
            // console.log(res);
            const response = res.data;
            let windowsList = [];
            if(response.code===200){
              response.data.windows.content.map((arr,i) => {
                const value = {
                  "label": arr.display_name,
                  "value": arr.display_name,
                  "id": arr.id,
                }
                windowsList.push(value);
              })
            }
            if(windowsList.length > 0) {
              this.setState({windowsList:windowsList});
            }
          }, (error) => {
            console.log(error);
        });
      }
      generateWindowFields = (windowId) => {
        //console.log('generateWindowFields==')
        // const params = this.props.match.params;
        if(isSet(windowId,null)===null){return false;}
        http.GET('field-groups/window/'+windowId+'/lookup-layouts')
        .then(windowResponse => {
            const responseData = windowResponse.data;
            if(responseData.code === 200) {
              this.setState({
                windowFields:{...this.state.windowFields,[windowId]:responseData.data,existWindowFields:responseData.data},
                selectedWindowId:responseData.data.window_id,
                selectedWindow:responseData.data.display_name
            })
            }
        }, (error) => {
            console.log(error);
        })
      }

    saveHandler = () => {
        const params = this.props.match.params;
        const { payload} = this.state;
        this.props.Loader();
        console.log("Save Automation process","payload",payload,"params",params)
        const updatedPayload = {
            ...payload,
            variable_type:'LOCAL',
            // window_id:selectedWindowId,
            reference_id :params.automationId,
            automation_id : params.automationId,
            fields:this.state.payload.fields
        }
        let APIMethod = http.POST;
        let ApiUrl = "variable/save";
        // if(isSet(payload.id,null)!==null){
        //     APIMethod = http.PUT;
        //     ApiUrl = "variable/"+payload.id+"/update"
        // }
        //console.log('updatedPayload==',updatedPayload); return false;
        
        APIMethod(ApiUrl,updatedPayload)
        .then(async (response) => {
            try{
                this.props.Loader();
                const responseData = response.data;
                if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
                    this.props.succMessage(responseData.message);
                    //this.props.closePopupToogle();
                    this.props.saveVariableAndFields();
                }else if(responseData.code === 400){
                    let violations = {};
                    responseData.violations.map((violation)=>{
                        violations = {
                            ...violations,
                            [violation.field_name]:violation.message
                        }
                    })
                    this.setState({
                        violations:violations
                    })
                }else {
                    this.props.failMessage(responseData.message);
                }
            }catch(e){
                console.log('e',e);
            }
            
        }).catch(err => {
            this.props.Loader();
            this.props.failMessage("Error occured");
                // console.log(err);
        })
    }
}



export default CreateNewVariable
    